
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexesDialog extends SiteEntityDialog<IndexesRow, any> {
        protected getFormKey() { return IndexesForm.formKey; }
        protected getIdProperty() { return IndexesRow.idProperty; }
        protected getLocalTextPrefix() { return IndexesRow.localTextPrefix; }
        protected getNameProperty() { return IndexesRow.nameProperty; }
        protected getService() { return IndexesService.baseUrl; }
        protected getDeletePermission() { return IndexesRow.deletePermission; }
        protected getInsertPermission() { return IndexesRow.insertPermission; }
        protected getUpdatePermission() { return IndexesRow.updatePermission; }

        protected form = new IndexesForm(this.idPrefix);

        constructor() {
            super();

            this.form.IndexTypeCode.changeSelect2(this.updateInterface.bind(this));
            this.form.IndexCode.change(() => this.form.BasketConstituents.indexCode = this.form.IndexCode.value);
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            fixSelect2Case(this.form.IndexTypeCode, this.entity?.IndexTypeCode);
            fixSelect2Case(this.form.LocalCurrencyCode, this.entity?.LocalCurrencyCode);
            fixSelect2Case(this.form.PriceSource1, this.entity?.PriceSource1);
            fixSelect2Case(this.form.PriceSource2, this.entity?.PriceSource2);
            fixSelect2Case(this.form.FxOtherCurrency, this.entity?.FxOtherCurrency);
            this.form.BasketConstituents.indexCode = this.form.IndexCode.value;
        }

        protected updateInterface() {
            super.updateInterface();

            var isFxRate = this.form.IndexTypeCode.value === "FXRATE";
            var isBasket = this.form.IndexTypeCode.value === "BASKET";
            this.form.FxOtherCurrency.getGridField().toggle(isFxRate);
            Serenity.EditorUtils.setRequired(this.form.FxOtherCurrency, isFxRate);
            this.form.BasketConstituents.getGridField().toggle(isBasket);
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            Q.reloadLookup(IndexesRow.lookupKey);
        }

        
    }
}

namespace Matrix {
    export function fixSelect2Case(editor: Serenity.Select2Editor<any, any>, value: string) {
        if ((editor.value != null && editor.value != "") || value == null || !value.length)
            return;

        value = value.toLowerCase();

        for (var item of editor.items) {
            if (item.id != null &&
                item.id.toLowerCase() == value) {
                editor.value = item.id;
                return;
            }
        }
    }
}